import { Fragment } from 'react';
import { LocalizedProperty } from '@mews/framework';
import { Divider, Typography, Stack } from '@optimus-web/core';
import { LocalizedLabel } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { ProductCheckListDataRow } from '../../types';
import { ProductCheckListDataTestIds } from '../../constants';
import { useFilteredProductsData } from './utils/useFilteredProductsData';

interface ProductsCellProps {
    row: ProductCheckListDataRow;
    active?: boolean;
}

export const ProductsCell: React.FC<ProductsCellProps> = ({ row, active = true }) => {
    const filteredProducts = useFilteredProductsData(row.productsData);

    if (!filteredProducts.length) {
        return (
            <LocalizedLabel
                variant="secondary"
                as="i"
                textKey={TextKey.NoProducts}
                data-test-id={ProductCheckListDataTestIds.cellProducts}
            />
        );
    }

    return (
        <Stack vertical fill alignment="center" spacing="100" data-test-id={ProductCheckListDataTestIds.cellProducts}>
            {filteredProducts.map(({ data }, index, self) => (
                <Fragment key={data.id}>
                    <Typography textStyle="bodyMediumStrong" variant={!active ? 'tertiary' : 'primary'} as="div">
                        <LocalizedProperty property={data.names} data-test-product-id={data.id} />
                    </Typography>
                    {index !== self.length - 1 && <Divider />}
                </Fragment>
            ))}
        </Stack>
    );
};
